// services/calculationSheet.ts
import api from './api';

// メンバーデータのインターフェース
export interface MemberData {
  date: string;
  superviser: string;
  members: string;
}

// 備考関連のインターフェース
export interface ExpenseDetail {
  price: number;
  detail: string;
}

export interface VendorDetail {
  price: number;
  detail: string;
}

export interface ConstructionRemark {
  remarks: string;
}

export interface ReportRemark {
  date: string;
  remarks: string;
}

export interface CalculationSheetData {
  title: string;
  inputDate: string;
  periodStart: string;
  periodEnd: string;
  companyName: string;
  companyIndex: number | null;
  siteName: string;
  address: string;
  workDetails: string;
  siteManager: string;
  estimatedAmount: number;
  miscExpenses: number;
  vendorOrders: number;
  laborCost: number;
  totalManpower: number;
  fuelCost: number;
  fuelPerVehicle: number;
  totalVehicles: number;
  totalVehicleCost: number;
  totalMileage: number;
  tollFees: number;
  totalProfit: number;
  memberData: MemberData[];
  baseProfit: number;
  supervisorCount: number;
  nonManagerSupervisorCount: number;
  nonManagerSupervisors: { date: string; superviser: string }[];
  supervisorAllowance: number;
  
  // 備考関連データ
  expenseDetails: ExpenseDetail[];
  vendorDetails: VendorDetail[];
  constructionRemarks: ConstructionRemark[];
  reportRemarks: ReportRemark[];
  remarks: string; // フォーマット済みの備考テキスト
}

export const calculationSheetService = {
  async getById(constructionId: number): Promise<CalculationSheetData> {
    try {
      const response = await api.get(`/calculation-sheet/${constructionId}`);
      
      if (response.data && response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.error || '計算書データの取得に失敗しました');
      }
    } catch (error) {
      console.error('計算書データ取得エラー:', error);
      throw error;
    }
  },
  
  // オプション機能: 詳細データの取得
  async getDetailedData(constructionId: number) {
    try {
      const response = await api.get(`/calculation-sheet/${constructionId}/detailed`);
      
      if (response.data && response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.error || '詳細データの取得に失敗しました');
      }
    } catch (error) {
      console.error('詳細データ取得エラー:', error);
      throw error;
    }
  }
};